import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import axios from 'axios'
import StatusToggle from '../ui/StatusToggle'
import ConfirmModal from '../ui/ConfirmModal'
import {
  EditIcon,
  DeleteIcon,
  ImportIcon,
  ViewIcon,
  AddIcon,
  ResetIcon,
  VideoIcon,
} from '../Icons'
import AddTest from './AddTest'
import EditTest from './EditTest'
// import Modal from './Modal' // Not used in new structure
// import DataTable from 'datatables.net-dt'
// import 'datatables.net-dt/css/jquery.dataTables.min.css'

// Skeleton loading component
const TableSkeleton = () => (
  <div className="animate-pulse">
    <table className="w-full">
      <thead className="bg-neutral-50">
        <tr>
          <th className="text-sm text-[#535862] font-medium text-center border w-[60px] px-2 py-3.5 border-[#F0F0F0]">
            S.No
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-28 px-2 py-3.5 border-[#F0F0F0]">
            Test Code
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-56 px-2 py-3.5 border-[#F0F0F0]">
            Test Name
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-32 px-2 py-3.5 border-[#F0F0F0]">
            No of Questions
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-40 px-2 py-3.5 border-[#F0F0F0]">
            Start Date
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-40 px-2 py-3.5 border-[#F0F0F0]">
            End Date
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-32 px-2 py-3.5 border-[#F0F0F0]">
            Status
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-32 px-2 py-3.5 border-[#F0F0F0]">
            Video Status
          </th>
          <th className="text-sm text-[#535862] font-medium text-center border w-96 px-2 py-3.5 border-[#F0F0F0]">
            Action
          </th>
        </tr>
      </thead>
      <tbody>
        {[...Array(5)].map((_, index) => (
          <tr key={index} className="border border-[#F0F0F0]">
            {[...Array(9)].map((_, i) => (
              <td
                key={i}
                className="text-center border px-2 py-2 border-[#F0F0F0]"
              >
                <div className="h-4 bg-gray-200 rounded w-16 mx-auto"></div>
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)

function TestList() {
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [entriesPerPage, setEntriesPerPage] = useState('100')
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedTestId, setSelectedTestId] = useState(null)
  const [isReportModalOpen, setIsReportModalOpen] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [testToDelete, setTestToDelete] = useState(null)
  const [resetModalOpen, setResetModalOpen] = useState(false)
  const [testToReset, setTestToReset] = useState(null)
  const navigate = useNavigate()
  const userId = localStorage.getItem('userid')

  // Status toggle logic
  const [statusModalOpen, setStatusModalOpen] = useState(false)
  const [statusModalAction, setStatusModalAction] = useState(null)
  // Video status toggle logic
  const [videoStatusModalOpen, setVideoStatusModalOpen] = useState(false)
  const [videoStatusModalAction, setVideoStatusModalAction] = useState(null)

  const [showAddTestModal, setShowAddTestModal] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTests()
      } catch (error) {
        console.error('Error loading data:', error)
        setIsLoading(false)
      }
    }
    fetchData()
  }, [])

  // Filter data based on search term
  const filteredData = data.filter(
    (item) =>
      item.test_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.test_title?.toLowerCase().includes(searchTerm.toLowerCase())
  )

  // Sort filteredData by createdAt in descending order (most recent first)
  const sortedData = [...filteredData].sort((a, b) => {
    const dateA = new Date(a.createdAt)
    const dateB = new Date(b.createdAt)
    return dateB - dateA
  })

  // Pagination logic
  const indexOfLastEntry = currentPage * parseInt(entriesPerPage)
  const indexOfFirstEntry = indexOfLastEntry - parseInt(entriesPerPage)
  const currentEntries = sortedData.slice(indexOfFirstEntry, indexOfLastEntry)
  const totalPages = Math.ceil(filteredData.length / parseInt(entriesPerPage))

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  // SAT-specific actions
  const deleteTest = async (id) => {
    if (window.confirm('Are you sure you want to delete test?')) {
      const response = await axios.delete(
        `${process.env.REACT_APP_BASE_URL}delete_sattest/${id}`
      )
      toast.success(response.data)
      getTests()
    }
  }

  const blockTest = async (id) => {
    if (window.confirm('Are you sure you want to deactivate test?')) {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}block_sattest/${id}`
      )
      toast.success(response.data)
      getTests()
    }
  }

  const unblockTest = async (id) => {
    if (window.confirm('Are you sure you want to activate test?')) {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}unblock_sattest/${id}`
      )
      toast.success(response.data)
      getTests()
    }
  }

  const blockVTest = async (id) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}block_vsattest/${id}`
    )
    toast.success(response.data)
    getTests()
  }

  const unblockVTest = async (id) => {
    const response = await axios.put(
      `${process.env.REACT_APP_BASE_URL}unblock_vsattest/${id}`
    )
    toast.success(response.data)
    getTests()
  }

  const getTests = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}getallsattests`
    )
    if (response.status === 200) {
      setData(response.data)
    }
    setIsLoading(false)
  }

  const ResetTest = async (id) => {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}reset_sattest/${id}/${userId}`
    )
    toast.success(response.data)
    getTests()
    window.location.reload(true)
  }

  // Modal handlers
  const handleDeleteClick = (id) => {
    setTestToDelete(id)
    setDeleteModalOpen(true)
  }
  const handleDeleteConfirm = async () => {
    if (testToDelete) {
      await deleteTest(testToDelete)
    }
    setDeleteModalOpen(false)
    setTestToDelete(null)
  }
  const handleDeleteCancel = () => {
    setDeleteModalOpen(false)
    setTestToDelete(null)
  }

  // Status toggle handlers
  const handleStatusToggle = (id, currentStatus) => {
    setStatusModalAction({ id, type: currentStatus ? 'block' : 'unblock' })
    setStatusModalOpen(true)
  }
  const handleStatusModalConfirm = async () => {
    if (statusModalAction) {
      if (statusModalAction.type === 'block') {
        await blockTest(statusModalAction.id)
      } else {
        await unblockTest(statusModalAction.id)
      }
    }
    setStatusModalOpen(false)
    setStatusModalAction(null)
  }
  const handleStatusModalCancel = () => {
    setStatusModalOpen(false)
    setStatusModalAction(null)
  }

  // Video status toggle handlers
  const handleVideoStatusToggle = (id, currentVStatus) => {
    setVideoStatusModalAction({
      id,
      type: currentVStatus ? 'block' : 'unblock',
    })
    setVideoStatusModalOpen(true)
  }
  const handleVideoStatusModalConfirm = async () => {
    if (videoStatusModalAction) {
      if (videoStatusModalAction.type === 'block') {
        await blockVTest(videoStatusModalAction.id)
      } else {
        await unblockVTest(videoStatusModalAction.id)
      }
    }
    setVideoStatusModalOpen(false)
    setVideoStatusModalAction(null)
  }
  const handleVideoStatusModalCancel = () => {
    setVideoStatusModalOpen(false)
    setVideoStatusModalAction(null)
  }

  // Reset modal handlers
  const handleResetConfirm = async () => {
    if (testToReset) {
      await ResetTest(testToReset)
    }
    setResetModalOpen(false)
    setTestToReset(null)
  }
  const handleResetCancel = () => {
    setResetModalOpen(false)
    setTestToReset(null)
  }

  return (
    <section className="bg-white border rounded-[10px] border-[#F0F0F0]">
      {/* Header Controls Section */}
      <div className="justify-between items-center border border-[#F0F0F0] flex w-full gap-[40px_100px] font-medium leading-[1.2] flex-wrap bg-white px-5 py-4 rounded-t-[10px]">
        <h2 className="text-lg text-[#030303] font-bold">SAT Tests List</h2>
        <div className="self-stretch flex min-w-60 items-center gap-2.5 text-xs text-[#535862] flex-wrap w-[750px] my-auto max-md:max-w-full">
          <div className="self-stretch flex items-center gap-[9px] my-auto">
            <div className="text-[#535862] self-stretch my-auto">
              Show Entries
            </div>
            <div className="self-stretch flex items-center gap-2 whitespace-nowrap text-center w-[90px] my-auto relative">
              <div className="justify-center items-stretch border border-[#F0F0F0] self-stretch flex w-[90px] flex-col bg-white my-auto px-2.5 py-[9px] rounded-[10px] border-solid relative">
                <select
                  className="text-[#535862] self-stretch my-auto bg-transparent outline-none appearance-none w-full pr-6"
                  value={entriesPerPage}
                  onChange={(e) => {
                    setEntriesPerPage(e.target.value)
                    setCurrentPage(1)
                  }}
                  aria-label="Entries per page"
                  style={{
                    WebkitAppearance: 'none',
                    MozAppearance: 'none',
                    appearance: 'none',
                  }}
                >
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                </select>
                <div className="pointer-events-none absolute right-3 top-1/2 transform -translate-y-1/2 flex w-4 h-4">
                  <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                    <path
                      d="M4 6l4 4 4-4"
                      stroke="#535862"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="self-stretch min-w-60 text-sm font-normal grow shrink w-[356px] my-auto rounded-[0px_0px_0px_0px]">
            <div className="flex items-center gap-1 border border-[#F0F0F0] bg-white px-3 py-2 rounded-md w-full focus-within:border-[#DE3C7D]">
              <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                <circle
                  cx="7.5"
                  cy="7.5"
                  r="6.5"
                  stroke="#535862"
                  strokeWidth="1.5"
                />
                <path
                  d="M14 14l-2.5-2.5"
                  stroke="#535862"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </svg>
              <input
                type="text"
                placeholder="Search test..."
                className="text-[#535862] bg-transparent outline-none border-none w-full"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
          </div>
          <button
            onClick={() => setShowAddTestModal(true)}
            className="justify-center items-stretch self-stretch flex flex-col text-white text-center grow shrink w-[140px] bg-[#DE3C7D] my-auto p-2.5 rounded-md flex-shrink-0 hover:bg-[#c8356f] transition-colors"
          >
            <div className="flex w-full gap-1 items-center justify-center">
              <div className="text-white">Add New SAT Test</div>
              <div className="flex w-3.5 shrink-0 h-3.5">
                <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                  <path
                    d="M8 3.333v9.334M3.333 8h9.334"
                    stroke="#fff"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>
          </button>
        </div>
      </div>
      {/* End Header Controls Section */}
      <div className="overflow-x-auto">
        {isLoading ? (
          <TableSkeleton />
        ) : (
          <>
            <table className="w-full">
              <thead className="bg-neutral-50">
                <tr>
                  <th className="text-sm text-[#535862] font-medium text-center border w-[60px] px-2 py-3.5 border-[#F0F0F0]">
                    S.No
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-28 px-2 py-3.5 border-[#F0F0F0]">
                    Test Code
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-56 px-2 py-3.5 border-[#F0F0F0]">
                    Test Name
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-32 px-2 py-3.5 border-[#F0F0F0]">
                    No of Questions
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-40 px-2 py-3.5 border-[#F0F0F0]">
                    Start Date
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-40 px-2 py-3.5 border-[#F0F0F0]">
                    End Date
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-32 px-2 py-3.5 border-[#F0F0F0]">
                    Status
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-32 px-2 py-3.5 border-[#F0F0F0]">
                    Video Status
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-80 px-2 py-3.5 border-[#F0F0F0]">
                    Action
                  </th>
                  <th className="text-sm text-[#535862] font-medium text-center border w-40 px-2 py-3.5 border-[#F0F0F0]">
                    Import / Export
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentEntries.length > 0 ? (
                  currentEntries.map((item, index) => {
                    let start_date = new Date(
                      item.start_date
                    ).toLocaleDateString('en-US')
                    let end_date = new Date(item.end_date).toLocaleDateString(
                      'en-US'
                    )
                    return (
                      <tr key={item._id} className="border border-[#F0F0F0]">
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          {indexOfFirstEntry + index + 1}
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          {item.test_code}
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          {item.test_title}
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          {item.no_of_questions}
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          {start_date}
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          {end_date}
                        </td>
                        <td
                          align="center"
                          className="text-center border px-2 py-2 border-[#F0F0F0]"
                        >
                          <StatusToggle
                            status={!!item.status}
                            onChange={() =>
                              handleStatusToggle(item._id, item.status)
                            }
                          />
                        </td>
                        <td
                          align="center"
                          className="text-center border px-2 py-2 border-[#F0F0F0]"
                        >
                          <StatusToggle
                            status={!!item.vstatus}
                            onChange={() =>
                              handleVideoStatusToggle(item._id, item.vstatus)
                            }
                          />
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          <div className="flex flex-wrap gap-1 justify-center">
                            <Link
                              title="Assign Batches"
                              to={`/assignbatches/${item._id}`}
                            >
                              <button
                                className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors text-[#535862]"
                                title="Assign Batches"
                              >
                                <AddIcon className="w-[14px] h-[14px] text-[#535862]" />
                              </button>
                            </Link>
                            <button
                              onClick={() => setSelectedTestId(item._id)}
                              className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                              title="Edit SAT Test"
                            >
                              <span className="text-[#535862]">
                                <EditIcon />
                              </span>
                            </button>
                            <button
                              className="border bg-[rgba(233,0,4,0.10)] p-2 rounded-[10px] border-[rgba(233,0,4,0.20)] hover:bg-[rgba(233,0,4,0.15)] transition-colors"
                              title="Delete SAT Test"
                              onClick={() => handleDeleteClick(item._id)}
                            >
                              <span className="text-[#E90004]">
                                <DeleteIcon />
                              </span>
                            </button>
                            <Link to={`/start/satquestion/${item._id}`}>
                              <button
                                className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                                title="Start SAT Test"
                              >
                                <span className="text-[#535862]">
                                  <VideoIcon />
                                </span>
                              </button>
                            </Link>
                            <Link to={`/sat/testresults/${item._id}`}>
                              <button
                                className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                                title="View Test Results"
                              >
                                <span className="text-[#535862]">
                                  <ViewIcon />
                                </span>
                              </button>
                            </Link>
                            <button
                              onClick={() => {
                                setTestToReset(item._id)
                                setResetModalOpen(true)
                              }}
                              className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                              title="Reset Test"
                            >
                              <ResetIcon />
                            </button>
                          </div>
                        </td>
                        <td className="text-center border px-2 py-2 border-[#F0F0F0]">
                          <div className="flex flex-wrap gap-1 justify-center">
                            <Link to={`/excelimport/${item._id}`}>
                              <button
                                className="border bg-neutral-50 p-2 rounded-[10px] border-[#F0F0F0] hover:bg-neutral-100 transition-colors"
                                title="Excel Import"
                              >
                                <ImportIcon className="text-[#535862]" />
                              </button>
                            </Link>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                ) : (
                  <tr>
                    <td
                      colSpan={10}
                      className="text-center py-8 text-[#535862]"
                    >
                      No tests found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {/* Pagination Controls */}
            {filteredData.length > 0 && (
              <div className="flex justify-between items-center mt-4 px-4">
                <div className="text-sm text-[#535862]">
                  Showing {indexOfFirstEntry + 1} to{' '}
                  {Math.min(indexOfLastEntry, filteredData.length)} of{' '}
                  {filteredData.length} entries
                </div>
                <div className="flex gap-2">
                  <button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-3 py-1 border border-[#F0F0F0] rounded-md disabled:opacity-50"
                  >
                    Previous
                  </button>
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index + 1}
                      onClick={() => handlePageChange(index + 1)}
                      className={`px-3 py-1 border border-[#F0F0F0] rounded-md ${
                        currentPage === index + 1
                          ? 'bg-[#DE3C7D] text-white'
                          : ''
                      }`}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="px-3 py-1 border border-[#F0F0F0] rounded-md disabled:opacity-50"
                  >
                    Next
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
      {/* Status Modal */}
      <ConfirmModal
        open={statusModalOpen}
        onConfirm={handleStatusModalConfirm}
        onCancel={handleStatusModalCancel}
        title={
          statusModalAction?.type === 'block'
            ? 'Deactivate Test'
            : 'Activate Test'
        }
        message={`Are you sure you want to ${
          statusModalAction?.type === 'block' ? 'deactivate' : 'activate'
        } this test?`}
      />
      {/* Video Status Modal */}
      <ConfirmModal
        open={videoStatusModalOpen}
        onConfirm={handleVideoStatusModalConfirm}
        onCancel={handleVideoStatusModalCancel}
        title={
          videoStatusModalAction?.type === 'block'
            ? 'Deactivate Video Status'
            : 'Activate Video Status'
        }
        message={`Are you sure you want to ${
          videoStatusModalAction?.type === 'block' ? 'deactivate' : 'activate'
        } video status for this test?`}
      />
      {/* Reset Modal */}
      {resetModalOpen && (
        <ConfirmModal
          open={resetModalOpen}
          onConfirm={handleResetConfirm}
          onCancel={handleResetCancel}
          title="Reset Test"
          message="Are you sure you want to reset this test?"
        />
      )}
      {/* Delete Modal */}
      {deleteModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg">
            <h3 className="text-lg font-bold mb-4">Delete Test</h3>
            <p className="mb-4">Are you sure you want to delete this test?</p>
            <div className="flex justify-end gap-2">
              <button
                onClick={handleDeleteCancel}
                className="px-4 py-2 bg-gray-200 rounded"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteConfirm}
                className="px-4 py-2 bg-[#DE3C7D] text-white rounded"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      {showAddTestModal && (
        <AddTest
          onClose={() => setShowAddTestModal(false)}
          onSuccess={() => {
            setShowAddTestModal(false)
            getTests()
          }}
        />
      )}
      {selectedTestId && (
        <EditTest
          testId={selectedTestId}
          onClose={() => setSelectedTestId(null)}
          onSuccess={() => {
            setSelectedTestId(null)
            getTests()
          }}
        />
      )}
      <ToastContainer />
    </section>
  )
}
export default TestList
